import React from "react";
import GrowlyImage from '../assets/images/Growly_IMG.png';
import TennisCenterCourt from '../assets/images/TennisCenterCourt.png';
import LofiMotors from '../assets/images/LofiMotors.png';
import '../assets/styles/Project.scss';

const projects = [
    {
        title: 'Growly',
        description: 'Platform that connects entrepreneurs and investors, helping them share ideas, access funding, and validate business opportunities.',
        image: GrowlyImage,
        link: 'https://errandi02.github.io/Growly-Sample'
    },
    {
        title: 'Tennis Center Court',
        description: 'Develop and manage a tennis blog with articles, tips, and reviews. Built with modern web technologies to offer a user-friendly interface and engaging content for the tennis community.',
        image: TennisCenterCourt,
        link: 'https://www.tenniscentercourt.com/'
    },
    {
        title: 'LoFi Motors',
        description: 'Content creator for LoFi Motors on YouTube, producing AI-generated music and animated visuals. Blend AI tools with creativity to deliver immersive LoFi experiences with futuristic cityscapes, chill beats, and relaxing vibes.',
        image: LofiMotors,
        link: 'https://www.youtube.com/@LOFIMOTORS'
    }
];

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects</h1>
        <div className="projects-grid">
            {projects.map((project) => (
                <div className="project" key={project.title}>
                    <a href={project.link} target="_blank" rel="noreferrer">
                        <img src={project.image} className="zoom" alt={`${project.title} thumbnail`} width="100%"/>
                    </a>
                    <a href={project.link} target="_blank" rel="noreferrer">
                        <h2>{project.title}</h2>
                    </a>
                    <p>{project.description}</p>
                </div>
            ))}
        </div>
    </div>
    );
}

export default Project;
